/*
 * Authors: mariushirjanu
 * Created: 30/08/2021
 */
import { ICompany } from '../../../../type_definitions/datatypes';
import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { TranslationService } from '../../../shared/translation/translation.service';

export const COMPANY_NOT_IN_LIST:string = 'companyNotInTheList';
export const EDIT_MODE:string = 'edit';

@Component({
  selector: 'duplicate-companies-dialog',
  template: `
    <div class="message-dialog duplicate-companies" [ngClass]="{error: isEditMode}">
      <div class="modal-header">
        <h4 class="modal-title" translate>APP.COMPANY.COMPANY_DUPLICATES_DIALOG.TITLE</h4>
      </div>

      <div class="modal-body">
        <div class="alert alert-danger" *ngIf="selectionFailure">
          <i class="fa fa-exclamation-circle"></i>&nbsp;<span translate>{{selectionFailure}}</span>
        </div>

        <h3>
          <span translate>APP.COMPANY.COMPANY_DUPLICATES_DIALOG.FOUND_DUPLICATES</span>&nbsp;<span class="highlight-text">{{input}}</span>
        </h3>

        <table class="table table-bordered table-striped">
          <thead>
            <tr>
              <th *ngIf="!isEditMode" class="text-center" translate>APP.COMPANY.COMPANY_DUPLICATES_DIALOG.SELECT</th>
              <th translate>GA.GENERAL.COMPANY</th>
              <th translate>GA.GENERAL.TYPE</th>
              <th translate>GA.GENERAL.CREATION_DATE</th>
              <th translate>GA.GENERAL.ID</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let result of results; trackById">
              <td *ngIf="!isEditMode" class="text-center">
                <input type="radio" name="selection" [(ngModel)]="model" [value]="result" (change)="updateOption()" id="opt_{{result.id}}"/>
              </td>
              <td>
                <label *ngIf="!isEditMode" for="opt_{{result.id}}">{{result.name}}</label>
                <span *ngIf="isEditMode">{{result.name}}</span>
              </td>
              <td>{{result.companyType}}</td>
              <td>{{result.creationDate}}</td>
              <td>{{result.id}}</td>
            </tr>
          </tbody>
        </table>

        <div *ngIf="!isEditMode" class="col-space-top">
          <div class="radio">
            <label>
              <input type="radio" name="selection" [(ngModel)]="model" [value]="companyNotInList" (change)="updateOption()">
              <span class="form-check-label bold text-primary">
                <span translate>APP.COMPANY.COMPANY_DUPLICATES_DIALOG.NOT_IN_LIST</span>.
                <span translate>APP.COMPANY.COMPANY_DUPLICATES_DIALOG.CREATE_NEW_COMPANY</span>
              </span>
            </label>
          </div>
        </div>

      </div>

      <div class="modal-footer footer-margin">
        <button *ngIf="!isEditMode" class="btn btn-success" (click)="continue()">{{buttonLabel}}</button>
        <button *ngIf="isEditMode" class="btn btn-default" (click)="continue()" translate>GA.BUTTONS.OK</button>
      </div>
    </div>
  `,
  styleUrls: [ './duplicate-companies.scss' ]
})

export class DuplicateCompaniesDialogComponent implements OnInit {
  @Input() public mode:string;
  @Input() public results:ICompany[];
  @Input() public input:string;
  @Output() public onSelected:EventEmitter<ICompany | string> = new EventEmitter<ICompany | string>(); // dialog callback

  public model:ICompany | string;
  public selectionFailure:string;
  //noinspection JSUnusedGlobalSymbols
  public isEditMode:boolean;
  //noinspection JSUnusedGlobalSymbols
  public companyNotInList:string = COMPANY_NOT_IN_LIST;

  private buttonLabels:string[] = [
    'GA.BUTTONS.CONTINUE',
    'APP.COMPANY.BUTTONS.USE_SELECTED_COMPANY'
  ];
  public buttonLabel:string = this.translationService.instant(this.buttonLabels[ 0 ]);

  constructor(
    private translationService:TranslationService
  ) {/***/
  }

  public ngOnInit():void {
    this.isEditMode = this.mode === EDIT_MODE;
  }

  public continue = ():void => {
    this.selectionFailure = undefined;

    if (this.model || this.isEditMode) {
      this.onSelected.emit(this.model);
    } else {
      this.selectionFailure = 'APP.COMPANY.SELECTION_REQUIRED';
    }
  };

  // noinspection JSUnusedGlobalSymbols
  public updateOption = ():void => {
    const label:number = !this.model || this.model === COMPANY_NOT_IN_LIST? 0 : 1;
    this.buttonLabel = this.translationService.instant(this.buttonLabels[ label ]);
  };
}